import { Header } from './index';
import { mapToLanguageCode } from '../utils';
import { ENGLISH, ENGLISH_WITHOUT_REGION } from '../constants/LanguageCodes';
import React from 'react';
import { getPersistedLanguage } from './LanguageSelector';
import { GREAT_BRITAIN } from '../constants/CountryCodes';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

const TitleContainer = styled.div`

  .backButton {
    display: none;
  }

  @media screen and (hover: none) and (min-device-aspect-ratio: 1/1) and (orientation: landscape) {
    .backButton {
      display: initial;
    }
  }
`;

const Details = styled.div`
  text-align: left;
`;

const ProductInfo = ({ product }) => {
  const { t } = useTranslation();

  if (!product) {
    return null;
  }

  const chosenLanguage = getPersistedLanguage(product.countryCode) === GREAT_BRITAIN.toUpperCase() ?
    ENGLISH_WITHOUT_REGION : getPersistedLanguage(product.countryCode).toLocaleLowerCase();

  return <TitleContainer>
    <Header>{product.name}</Header>
    <Details>
      {product.description ?
        <p>{product.description[mapToLanguageCode(chosenLanguage) === ENGLISH ? ENGLISH_WITHOUT_REGION :
          mapToLanguageCode(chosenLanguage)]}</p> : <></>}
      {product.fixedDuration ? <p>{t('parkingMinutes')} : {product.fixedDuration}</p> : <></>}
      <p>{product.placeName}</p>
    </Details>
  </TitleContainer>;
};

export default ProductInfo;
